export const actionTypes = {
  SET: 'APP.INCOMING_DATA.SET',
};

export function setData(data) {
  return {
    type: actionTypes.SET,
    payload: data,
  };
}
